import useColumnLocation from '../hooks/use-column-location'

export default function WhenInTableFooter ({ children }) {
  const location = useColumnLocation()

  return location === 'footer' ? children : null
}
